import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SquaresFour, UploadSimple, Gear, ChartBar, Gift } from '@phosphor-icons/react';
import { motion } from 'framer-motion';

const Layout = ({ children, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/dashboard', icon: SquaresFour, label: 'Dashboard' },
    { path: '/upload', icon: UploadSimple, label: 'Upload' },
    { path: '/high-value', icon: ChartBar, label: 'High Value' },
    { path: '/rewards', icon: Gift, label: 'Rewards' },
    { path: '/categories', icon: Gear, label: 'Settings' },
  ];

  return (
    <div className="min-h-screen bg-background pb-20">
      <main className="w-full max-w-md mx-auto relative z-0">
        {children}
      </main>

      {/* Bottom Navigation */}
      <motion.nav
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-border z-10"
        data-testid="bottom-navigation"
      >
        <div className="w-full max-w-md mx-auto px-4 py-2">
          <div className="flex items-center justify-around">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className="flex flex-col items-center gap-0.5 py-1 px-2 transition-colors"
                  data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                >
                  <Icon
                    size={24}
                    weight={isActive ? 'fill' : 'regular'}
                    className={isActive ? 'text-primary' : 'text-muted-foreground'}
                  />
                  <span
                    className={`text-[10px] font-medium ${
                      isActive ? 'text-primary' : 'text-muted-foreground'
                    }`}
                  >
                    {item.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </motion.nav>
    </div>
  );
};

export default Layout;